export interface ErrorHandler {
    handle(err: any): void;
}

export interface ErrorLoggingService {
    logError(err: any): void;
}

export interface HttpResponse {
    data: any;
    status: number;
    headers: any;
}

export interface HttpError {
    response?: HttpResponse;
    request?: any;
    message?: string;
}

export interface HttpRequest {
    url: string;
    method: HttpMethodUnion;
    params?: any;
}

export interface HttpService {
    get<T>(url: string, params?: any): Promise<HttpServiceResponse<T>>;
    post<T>(url: string, params?: any): Promise<HttpServiceResponse<T>>;
    put<T>(url: string, params?: any): Promise<HttpServiceResponse<T>>;
    delete<T>(url: string): Promise<HttpServiceResponse<T>>;
    request<T>(request: HttpRequest): Promise<HttpServiceResponse<T>>;
}

export type HttpServiceResponse<T> = [T | null, HttpError | null, HttpResponse?];

export enum HttpMethod {
    GET = 'GET',
    HEAD = 'HEAD',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
    OPTIONS = 'OPTIONS',
    TRACE = 'TRACE',
}

export type HttpMethodUnion = 'GET' | 'HEAD' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | 'TRACE';
